import React, { useCallback } from 'react';
import { Route, Switch } from 'react-router';
import InboxPage from '../components/InboxPage/InboxPage';
import { UserAgent } from './App';
import { NotFoundNoticeUI } from '@indeed/messaging-react';

interface AppRouterProps {
    userAgent: UserAgent;
}

const AppRouter = ({ userAgent }: AppRouterProps) => {
    const InboxPageWithUserAgent = useCallback(() => {
        return <InboxPage userAgent={userAgent} />;
    }, [userAgent]);

    return (
        <Switch>
            <Route exact path={['/', '/conversations']} component={InboxPageWithUserAgent} />
            <Route exact path="/conversations/new" component={InboxPageWithUserAgent} />
            <Route
                path="/conversations/:encryptedConversationId"
                component={InboxPageWithUserAgent}
            />
            <Route component={NotFoundNoticeUI} />
        </Switch>
    );
};

export default AppRouter;
